var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgViewFilled = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 20, height: 14.667 }, props, { children: _jsxs("g", __assign({ transform: "translate(-.5 -2.5)" }, { children: [_jsx("circle", { "data-name": "Ellipse 11", cx: 2.667, cy: 2.667, r: 2.667, transform: "translate(7.833 7.167)" }), _jsx("path", { "data-name": "Path 124", d: "M20.46 9.607A11.127 11.127 0 0 0 10.5 2.5 11.127 11.127 0 0 0 .54 9.607a.667.667 0 0 0 0 .453 11.127 11.127 0 0 0 9.96 7.107 11.127 11.127 0 0 0 9.96-7.107.667.667 0 0 0 0-.453Zm-9.96 4.56a4.333 4.333 0 1 1 4.333-4.333 4.333 4.333 0 0 1-4.333 4.333Z" })] })) }))); };
export default SvgViewFilled;
